const n = {
  name: "Greenland",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 1.63818V0H11V1.63767L6.53139 7H5V8.83767L4.86475 8.99998L6.26465 9L7 11.3531V22H4V24H20V22H17V11.3521L17.735 9L19.1348 8.99998L19 8.83818V7H17.4682L13 1.63818ZM9 22V13H15V22H9ZM11 9V11H8.98503L8.36003 9H11ZM15.0146 11H13V9H15.6396L15.0146 11ZM9.13483 6.99998L11.9998 3.56203L14.8647 6.99998H9.13483Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as Greenland
};
